import React from 'react';
import { faTimes, faSave, faTimesCircle, faKey, faBan } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface IEducatorLaunchboxProps {
  isReadOnly: boolean;
  onSave: () => void;
  onValidate: () => boolean;
  isSaving: boolean;
  isDeleting: boolean;
  isGeneratingActivationKey: boolean;
  isRevokingActivationKey: boolean;
  onDelete: () => void;
  onGenerateActivationKey: () => void;
  canRevokeActivationKey: boolean;
  onRevokeActivationKey: () => void;
}

export function EducatorLaunchbox(props: IEducatorLaunchboxProps) {
  const {
    isReadOnly,
    isSaving,
    isDeleting,
    isGeneratingActivationKey,
    isRevokingActivationKey,
    onSave,
    onValidate,
    onDelete,
    onGenerateActivationKey,
    canRevokeActivationKey,
    onRevokeActivationKey,
  } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  return (
    <FloatingActionButtonBar>
      {!isReadOnly && (
        <>
          <FloatingActionButton
            loading={isGeneratingActivationKey}
            buttonText={
              <>
                <span>Generér</span>
                <br />
                <span>aktiveringsnøgle</span>
              </>
            }
            icon={faKey}
            onClick={onGenerateActivationKey}
          />
          <FloatingActionButton
            loading={isRevokingActivationKey}
            buttonText={
              <>
                <span>Tilbagekald</span>
                <br />
                <span>aktiveringsnøgle</span>
              </>
            }
            icon={faBan}
            onClick={onRevokeActivationKey}
            disabled={!canRevokeActivationKey}
            disabledTooltipText="Underviseren har ingen aktiveringsnøgle eller tilknyttet enhed"
          />
          <FloatingActionButton loading={isDeleting} buttonText="Slet" icon={faTimesCircle} onClick={onDelete} />
          <FabDivider />
          <FloatingActionButton loading={isSaving} buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted />
        </>
      )}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
